import React, { Component } from 'react';
import { connect } from 'react-redux';
import MobileSidebarWrapper from './styles/m-sidebar.style';
import MobileViewDetails from '../../../components/viewDetails/mobile/mobileviewDetailspopover';
import * as TherapistActions from '../../../actions/therapist';
import { Scrollbars } from 'react-custom-scrollbars-2';
import moment from 'moment';
import { getSecondsInTextTime } from '../../../utils/getInititials';


class MobileSidebar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: false,
			currentActiveCall : undefined
		};
		this.openSidebar=this.openSidebar.bind(this);
		this.closeSidebar=this.closeSidebar.bind(this);
		this.openViewDetail=this.openViewDetail.bind(this);
		this.closeViewDetail=this.closeViewDetail.bind(this);
		
	}

	openSidebar() {
        this.setState({ active: true });
	}
	closeSidebar() {
		this.setState({ active: false });	
		this.props.closeSidebar(); 
	}

	openViewDetail(call){
		const { dispatch } = this.props;
		this.setState({
			openViewDetail:true,
			currentActiveCall : call
		});   
		dispatch(TherapistActions.unsetActiveCallDetails());
		dispatch(TherapistActions.getActiveCallDetails({callId : call.callId}));
	}

	closeViewDetail() {
		this.setState({ openViewDetail: false, currentActiveCall : undefined });	
	}

	render() {
		const { therapists, changeCallStatus } = this.props;
		const { todayVisits, activeCallHistory } = therapists;
		let startButtonText = "start call"
		activeCallHistory.forEach(activeCall => {
			if(activeCall.callStatus.toLowerCase() === "on call"){
				startButtonText = "merge call"
			}
		})
		
		return (
			<MobileSidebarWrapper>
			<div className={this.state.active || this.props.openSidebar ? 'overlay show': 'overlay hide'}></div>
			<aside className={this.state.active || this.props.openSidebar ? 'page-header slidein': 'page-header slideout'}>
			<nav>
				<a><img className="logo" src="/images/kure-logo.png" width="70" alt="kure logo" /></a>
				<h3>video room</h3>
			</nav>
			<span className="close-sidebar" onClick={this.closeSidebar}>&times;</span>
			<Scrollbars>
			<div className="scrollable-content">
			<section className="patient-queue">
				<h1 className="section-title">waiting room</h1>
				{activeCallHistory && activeCallHistory.length > 0 ? <div className="patient-lists">
				<ul>
				{activeCallHistory.map(activeCall => 
						<li className={activeCall.callStatus.toLowerCase() === "on call" ? "active" : ""} key={activeCall.callId}>
						<div className="patient-cards">
							<div className="patient-detail">
								<h1>{activeCall.patient}</h1>
							{activeCall.callStatus.toLowerCase() === "on call" ? 
								<h2></h2>:
								<h2>Waiting  {getSecondsInTextTime(activeCall.waitingTime)}</h2>}
							</div>
							<div className="actions">
							{activeCall.callStatus.toLowerCase() === "on call" ? 
								<button className="end-call kurebtn" onClick={() => changeCallStatus("End Call", activeCall.callId)}>end call</button>:

								<button className="start-call kurebtn" onClick={() => changeCallStatus("On Call", activeCall.callId)}>{startButtonText}</button>}
								<button className="visit-details kurebtn" onClick={() => this.openViewDetail(activeCall)}>visit details</button>
								
							</div>
						</div>
					</li>
					)}
				
				</ul>
				</div> :
				<h2 className="no-patient-heading">No one has checked in yet</h2>
			}
			</section>
			<MobileViewDetails currentActiveCall={this.state.currentActiveCall} 
								openViewDetail={this.state.openViewDetail} 
								onCallStatus={this.state.currentActiveCall && this.state.currentActiveCall.callStatus.toLowerCase() === "on call"}
								removeCall={() => {
									changeCallStatus("End Call", this.state.currentActiveCall.callId);
									this.closeViewDetail();
								}}
								closeViewDetail={this.closeViewDetail} />
			<section className="provider-schedule">
			<h1 className="section-title">FROM YOUR SCHEDULE TODAY</h1>
			<div className="provider-schedule-lists">
				<ul>
				{todayVisits.map((visit, index) => {
					return <li key={index}>
						<div className="schedule-card">
							<h3>{visit.patientinfo.FirstName + " " + visit.patientinfo.LastName}</h3>
							<h2>DOB: {visit.patientinfo.DOB && moment(visit.patientinfo.DOB).format("MM/DD/YYYY")}, 9 years old</h2>
							{false && visit.parentName && visit.parentName !== "" && <h1>caregiver</h1>}
							{false && visit.parentName && visit.parentName !== "" && <h3>{visit.parentName}</h3>}
							{false && visit.parentName && visit.parentName !== "" && <h2 className="p-0">{visit.phoneNumber}</h2>}
							{false && <h2>{visit.relation}</h2>}
							<h1>visit type</h1>
							<h2>{visit.Type}</h2>
							<h1>confirmation status</h1>
							<h2>{visit.Status}</h2>
						</div>
					</li>})}
				</ul>
			</div>
			</section>
			
			</div>
			
			</Scrollbars>
		</aside>
		
			</MobileSidebarWrapper>
		  ) 
	}
}

export default connect(
	state => state
)(MobileSidebar);
